import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { services } from '../../mocks/services';

export default function ServicesPage() {
  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="bg-parkside-dark pt-32 pb-16">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <p className="text-parkside-amber text-sm font-semibold uppercase tracking-widest mb-3">What We Do</p>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Paver & Hardscape Services</h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              From custom driveways and pool decks to full outdoor living spaces — Parkside Pavers delivers premium hardscape solutions throughout Tampa Bay.
            </p>
            <div className="flex justify-center gap-4 mt-8">
              <Link to="/contact" className="bg-parkside-amber text-white font-semibold px-7 py-3.5 rounded-md hover:bg-parkside-amber/90 transition-colors whitespace-nowrap cursor-pointer">
                Get a Free Estimate
              </Link>
              <a href="tel:813-404-6313" className="border border-white/30 text-white font-semibold px-7 py-3.5 rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2" />813-404-6313
              </a>
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service) => (
                <Link
                  key={service.id}
                  to={service.slug}
                  className="group bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-parkside-green/30 transition-all cursor-pointer"
                >
                  <div className="w-full h-56 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <div className="w-10 h-10 flex items-center justify-center bg-parkside-green/10 rounded-lg mb-3">
                      <i className={`${service.icon} text-parkside-green text-xl`} />
                    </div>
                    <h2 className="text-parkside-dark font-bold text-xl mb-2">{service.title}</h2>
                    <p className="text-parkside-stone text-sm leading-relaxed mb-4">{service.description}</p>
                    <span className="text-parkside-green font-semibold text-sm flex items-center gap-1 group-hover:gap-2.5 transition-all">
                      Learn More <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Strip */}
        <section className="py-16 bg-parkside-green">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-3">Not Sure Which Service You Need?</h2>
            <p className="text-white/70 mb-8">We&apos;re happy to help. Call us or request a free on-site consultation and we&apos;ll guide you to the right solution.</p>
            <div className="flex justify-center gap-4 flex-wrap">
              <Link to="/contact" className="bg-white text-parkside-green font-bold px-8 py-3.5 rounded-md hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer">
                Request Free Consultation
              </Link>
              <a href="tel:813-404-6313" className="border border-white/40 text-white font-semibold px-8 py-3.5 rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2" />Call 813-404-6313
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
